module.exports = self["Phaser"];